import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Calendar, List, Star } from 'lucide-react';
import GestisciMatch from './GestisciMatch';
import CalendarioColloqui from './CalendarioColloqui';
import FeedbackRiepilogo from './FeedbackRiepilogo';

const GestisciMatchContainer = ({ agencyId }) => {
  const [activeTab, setActiveTab] = useState('lista');

  return (
    <div className="space-y-4">
      {/* Tabs */}
      <Card>
        <CardContent className="p-4">
          <div className="flex gap-2 overflow-x-auto">
            <Button
              onClick={() => setActiveTab('calendario')}
              variant={activeTab === 'calendario' ? 'default' : 'outline'}
              className={activeTab === 'calendario' ? 'bg-blue-600' : ''}
            >
              <Calendar className="w-4 h-4 mr-2" />
              📅 Calendario Colloqui
            </Button>
            <Button
              onClick={() => setActiveTab('lista')}
              variant={activeTab === 'lista' ? 'default' : 'outline'}
              className={activeTab === 'lista' ? 'bg-blue-600' : ''}
            >
              <List className="w-4 h-4 mr-2" />
              👥 Lista Match
            </Button>
            <Button
              onClick={() => setActiveTab('feedback')}
              variant={activeTab === 'feedback' ? 'default' : 'outline'}
              className={activeTab === 'feedback' ? 'bg-blue-600' : ''}
            >
              <Star className="w-4 h-4 mr-2" />
              ⭐ Feedback Colloqui
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Content */}
      {activeTab === 'calendario' && <CalendarioColloqui agencyId={agencyId} userType="agency" />}
      {activeTab === 'lista' && <GestisciMatch agencyId={agencyId} />}
      {activeTab === 'feedback' && <FeedbackRiepilogo agencyId={agencyId} />}
    </div>
  );
};

export default GestisciMatchContainer;
